import { createShipmentCreationSlice } from '@/modules/shipment-creation/createShipmentSlice';
import { ROAD_TRANSPORT_CONFIG } from '@/modules/shipment-creation/configs';

const roadTransport = createShipmentCreationSlice(ROAD_TRANSPORT_CONFIG);

export const roadTransportSliceActions = roadTransport.actions;
export const roadTransportSliceSelectors = roadTransport.selectors;

export const {
  setStep,
  goToNextStep,
  goToPreviousStep,
  updateBasicDetails,
  updateParty,
  clearParty,
  updateCargo,
  triggerValidation,
  hideValidation,
  resetForm,
  loadDraftData,
  setSyncStatus,
  setShipmentId,
  setSyncError,
  clearSyncState,
} = roadTransport.actions;

export const selectCreateRoadTransport = roadTransport.selectors.selectRoot;
export const selectCurrentStep = roadTransport.selectors.selectCurrentStep;
export const selectFormData = roadTransport.selectors.selectFormData;
export const selectBasicDetails = roadTransport.selectors.selectBasicDetails;
export const selectCargo = roadTransport.selectors.selectCargo;
export const selectValidation = roadTransport.selectors.selectValidation;
export const selectShowErrors = roadTransport.selectors.selectShowErrors;
export const selectSync = roadTransport.selectors.selectSync;
export const selectIsDirty = roadTransport.selectors.selectIsDirty;
export const selectShipmentId = roadTransport.selectors.selectShipmentId;

export type { ShipmentCreationStep as CreateRoadTransportStep } from '@/modules/shipment-creation/types';
export type { ShipmentParty as RoadTransportParty } from '@/modules/shipment-creation/types';
export type { ShipmentOrganizationLocation as RoadTransportOrganizationLocation } from '@/modules/shipment-creation/types';
export type { ShipmentBasicDetailsData as RoadTransportBasicDetailsData } from '@/modules/shipment-creation/types';
export type { ShipmentCargoStepData as RoadTransportCargoStepData } from '@/modules/shipment-creation/types';
export type { ShipmentCreationFormData as CreateRoadTransportFormData } from '@/modules/shipment-creation/types';
export type { ShipmentSyncStatus as RoadTransportSyncStatus } from '@/modules/shipment-creation/types';
export type { ShipmentSyncState as RoadTransportSyncState } from '@/modules/shipment-creation/types';
export type { ShipmentPartyType as RoadTransportPartyType } from '@/modules/shipment-creation/types';
export type { ValidationErrors } from '@/modules/shipment-creation/types';
export type { ShipmentCreationState as CreateRoadTransportState } from '@/modules/shipment-creation/types';

export default roadTransport.reducer;
